module.exports = __webpack_public_path__ + "../resources/images/illustration_error-88db2bdffd691216e14c2892b2255eb7.svg";